import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NbDialogRef } from '@nebular/theme';
import { News } from '../../models/news';
import { NewsService } from '../../services/news-service';
import * as momentHijri from 'moment-hijri';


@Component({
  selector: 'app-get-news-details',
  templateUrl: './get-news-details.component.html',
  styleUrls: ['./get-news-details.component.scss'],
})
export class GetNewsDetailsComponent implements OnInit {
  model = {} as News;
  constructor(
    private route: Router,
    private diag: NbDialogRef<GetNewsDetailsComponent>,
    public sanitizer: DomSanitizer,
    private service: NewsService
  ) {}

  ngOnInit() {
      this.route.events.subscribe(()=>{
      this.diag.close('false');
     });
  }
  getLabelData(text) {
    return this.sanitizer.bypassSecurityTrustHtml(text);
  }

  close() {
    this.diag.close();
  }

  downloadFile(fileName) {
    this.service.downloadFile(fileName).subscribe();
  }

   getHijriDate(date) {
      return momentHijri(date, 'YYYY-MM-DD').format('iYYYY/iM/iD');
    }
}
